import { debounce } from '@ifeng-fe/ui_base';
import store from '../../../../reduxStore';
import { actions } from '../../../../model';

export const clearAllThermograms = () => {
    const outBox = document.querySelector('.visualediting-statistics-outBox');

    if (outBox) {
        document.body.removeChild(outBox);
    }
    const innerBoxs = document.querySelectorAll('.statistics-inner-box');

    for (const innerBox of innerBoxs) {
        innerBox.parentElement.removeChild(innerBox);
    }
};

const getLevelStyle = val => {
    val = parseFloat(val);
    if (val > 10) {
        return 'visualediting-statistics-style1';
    } else if (val > 5) {
        return 'visualediting-statistics-style2';
    } else if (val > 1) {
        return 'visualediting-statistics-style3';
    } else {
        return 'visualediting-statistics-style4';
    }
};

export default debounce(() => {
    const data = store.getState().thermograms;

    if (data.length <= 0) {
        return;
    }
    console.log('hot Render');
    clearAllThermograms();
    const boxs = document.createDocumentFragment();
    const outBox = document.createElement('div');

    outBox.classList.add('visualediting-statistics-outBox');
    boxs.appendChild(outBox);
    const topRect = document.body.getBoundingClientRect();

    for (const link of data) {
        const link1 = link.URL.split('//')[1] || link.URL.split('//')[0];
        const selectedLinks = document.querySelectorAll(`a[href$="${link1}"]`);

        for (const item of selectedLinks) {
            if (item.dataset.innermask) {
                const div = document.createElement('div');

                div.setAttribute('data-url', item.href);
                div.classList.add('statistics-inner-box');
                div.classList.add('visualediting-statistics-base-style');
                div.classList.add(getLevelStyle(link.RATE));
                div.innerHTML = `${link.RATE}<span> | ${link.UV}</span>`;
                div.title = `${link.RATE} | ${link.UV}`;
                item.appendChild(div);
            } else if (item.dataset.nomask) {
                continue;
            } else {
                const rect = item.getBoundingClientRect();
                const div = document.createElement('div');

                div.style.top = `${rect.y - topRect.y}px`;
                div.style.left = `${rect.x - topRect.x}px`;
                div.style.width = `${rect.width}px`;
                div.style.height = `${rect.height}px`;
                div.setAttribute('data-url', item.href);
                div.classList.add('statistics-box');
                div.classList.add('visualediting-statistics-base-style');
                div.classList.add(getLevelStyle(link.RATE));
                div.innerHTML = `${link.RATE}<span> | ${link.UV}</span>`;
                div.title = `${link.RATE} | ${link.UV}`;
                outBox.appendChild(div);
            }
        }
    }
    store.dispatch(
        actions.uiStateUpdate({
            isClearThermogram: false,
        }),
    );

    document.body.appendChild(boxs);
}, 100);
